import { Swiper } from 'swiper';
import { A11y, Navigation } from 'swiper/modules';

const blocks = document.querySelectorAll('.block-testimonial-cards');

if (blocks.length > 0) {
	blocks.forEach((block) => {
		const slider = block.querySelector('.block-testimonials .swiper');

		if (!slider) {
			return;
		}

		let cardsPerRow = 3;

		if (block.hasAttribute('data-cards-per-row')) {
			cardsPerRow = parseInt(block.getAttribute('data-cards-per-row'));
		}

		const settings = {
			loop: true,
			grabCursor: true,
			spaceBetween: 32,
			slidesPerView: 1,
			modules: [A11y, Navigation],
			a11y: {
				itemRoleDescriptionMessage: 'slide',
			},
			navigation: {
				prevEl: slider.parentElement.querySelector(
					'.swiper-button-prev'
				),
				nextEl: slider.parentElement.querySelector(
					'.swiper-button-next'
				),
			},
			breakpoints: {
				576: {
					slidesPerView: 2,
				},
				992: {
					slidesPerView: cardsPerRow,
				},
			},
		};

		new Swiper(slider, settings);
	});
}
